"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var telepath_unpack_1 = __importDefault(require("telepath-unpack"));
// Prevent double-initialisation if imported twice
// This was introduced because both the sidebar and the page editor
// use telepath, but they use separate hooks for JS dependencies so we
// can't de-duplicate the telepath import.
if (!window.telepath) {
    window.telepath = new telepath_unpack_1["default"]();
}
